import React from "react";

export const EditIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.6845 2.99851L13.0017 5.31571M4.74999 4.75022H2.3125C2.09701 4.75022 1.89035 4.83582 1.73798 4.98819C1.5856 5.14056 1.5 5.34722 1.5 5.5627V13.6875C1.5 13.903 1.5856 14.1097 1.73798 14.262C1.89035 14.4144 2.09701 14.5 2.3125 14.5H11.25C11.4655 14.5 11.6721 14.4144 11.8245 14.262C11.9769 14.1097 12.0625 13.903 12.0625 13.6875V10.0314M14.0198 1.97966C14.172 2.13184 14.2928 2.31252 14.3752 2.51139C14.4576 2.71025 14.5 2.9234 14.5 3.13866C14.5 3.35392 14.4576 3.56707 14.3752 3.76594C14.2928 3.9648 14.172 4.14549 14.0198 4.29767L8.45905 9.85829L5.56249 10.4376L6.1418 7.54109L11.7025 1.98047C11.8546 1.82816 12.0352 1.70732 12.234 1.62488C12.4328 1.54244 12.6459 1.5 12.8612 1.5C13.0764 1.5 13.2895 1.54244 13.4883 1.62488C13.6871 1.70732 13.8677 1.82816 14.0198 1.98047V1.97966Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/AdCardActions/EditIcon.tsx